module.exports = __webpack_public_path__ + "static/media/mum_cutting_grass.88fa8d7e.gif";